// $(document).ready(function () {
//   $(".complete-the-look-slider").flickity({
//     cellAlign: "left",
//     contain: true,
//     freeScroll: false,
//     wrapAround: true,
//     pageDots: true,
//     resize: true,
//     arrowShape: { 
//     x0: 10,
//     x1: 60, y1: 50,
//     x2: 60, y2: 45,
//     x3: 15
//   }
//   });
// });


$(document).ready(function () {
  $(".complete-the-look-slider").imagesLoaded( function() {
    $(".complete-the-look-slider").flickity({
      cellAlign: "left",
      contain: true,
      freeScroll: false,
      wrapAround: true,
      pageDots: true,
      resize: true,
      arrowShape: { 
        x0: 10,
        x1: 60, y1: 50,
        x2: 60, y2: 45,
        x3: 15
      }
    });
  });
});